import { z } from 'zod';

export const allLicenses = ['free', 'expired', 'pro', 'trial', 'expiring', 'school', 'start'] as const;

/**
 * all possible status codes of a license
 * this should probably be refactored at some point, suggestion would be to
 * - expiring and trial are the same, these should be merged to 1 (trial)
 * - free and expired are the same, free doesn't seem to be used for new accounts, but it still supported. these 2 should probably both be removed
 * - expiring should not be a status. we have an expire date for that. Each license is able to expire
 */
export const DbSupportedLicenseStatusSchema = z.enum(allLicenses);

export const DbSchoolSubscriptionTierTypesSchema = z.enum(['basic', 'complete', 'plus', 'pay-per-use']);

/**
 * @deprecated use DbSupportedLicenseStatus instead
 */
export type LicenseStatus = (typeof allLicenses)[number];

export type DbSupportedLicenseStatus = z.infer<typeof DbSupportedLicenseStatusSchema>;
export type DbSchoolSubscriptionTierType = z.infer<typeof DbSchoolSubscriptionTierTypesSchema>;
